import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-fluent-component/wizard';
import { LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';

const getStyles = () => ({
  footerContainer: {
    display: 'flex',
    columnGap: '10px',
    marginTop: '20px',
  },
});

export const LinkedInAdFooter = () => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const { send } = useWizardService();

  const onSaveAndCreateAnotherAd = () => {
    send({
      type: WIZARD_EVENTS.SAVE_AND_GOTO,
      flowFactors: { isMultiAdModel: true },
      stepId: LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER,
    });
  };

  return (
    <div className={classNames([classes.footerContainer, 'linkedin-ads-footer'])}>
      <Button
        appearance="secondary"
        onClick={onSaveAndCreateAnotherAd}
        className="save-and-create-another-ad-button"
      >
        {i18n.getString(_TL_('Save & create another ad'))}
      </Button>
    </div>
  );
};
